import React from 'react';
import classnames from 'classnames';
import { Button, Upload } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import './styles.less';
      
const UploadButton = ( { onAdd, accept, className, children } ) => {

    const classes = classnames( [
        'upload-file-button',
        { [ className ]: Boolean( className ) },
    ] );

    return (
        <Upload
            fileList={ [] }
            className={ classes }
            accept={ accept }
            beforeUpload={ file => {
                if ( onAdd ) {
                    onAdd( file );
                }
            } }
        >
            <Button className="upload-file-wrapper-button">
                <div className="inner-content">
                    <CloudUploadOutlined />
                    <br />
                    { children }
                </div>
            </Button> 
        </Upload>
    );
};

export default UploadButton;
